// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/@jupyterlab/builder/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@jupyterlab/builder/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/@jupyterlab/builder/node_modules/css-loader/dist/cjs.js!./lumino.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/@jupyterlab/builder/node_modules/css-loader/dist/cjs.js!./nouislider.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/@jupyterlab/builder/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOCAxOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTggMTg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO30KPC9zdHlsZT4KPHBhdGggZD0iTTUuMiw1LjlMOSw5LjdsMy44LTMuOGwxLjIsMS4ybC00LjksNWwtNC45LTVMNS4yLDUuOXoiLz4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTAtMC42aDE4djE4SDBWLTAuNnoiLz4KPC9zdmc+Cg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

/*
 * We assume that the CSS variables in
 * https://github.com/jupyterlab/jupyterlab/blob/master/src/default-theme/variables.css
 * have been defined.
 */

:root {
  --jp-widgets-color: var(--jp-content-font-color1);
  --jp-widgets-label-color: var(--jp-widgets-color);
  --jp-widgets-readout-color: var(--jp-widgets-color);
  --jp-widgets-font-size: var(--jp-ui-font-size1);
  --jp-widgets-margin: 2px;
  --jp-widgets-inline-height: 28px;
  --jp-widgets-inline-width: 300px;
  --jp-widgets-inline-width-short: calc(
    var(--jp-widgets-inline-width) / 2 - var(--jp-widgets-margin)
  );
  --jp-widgets-inline-width-tiny: calc(
    var(--jp-widgets-inline-width-short) / 2 - var(--jp-widgets-margin)
  );
  --jp-widgets-inline-margin: 4px; /* margin between inline elements */
  --jp-widgets-inline-label-width: 80px;
  --jp-widgets-border-width: var(--jp-border-width);
  --jp-widgets-vertical-height: 200px;
  --jp-widgets-horizontal-tab-height: 24px;
  --jp-widgets-horizontal-tab-width: 144px;
  --jp-widgets-horizontal-tab-top-border: 2px;
  --jp-widgets-progress-thickness: 20px;
  --jp-widgets-container-padding: 15px;
  --jp-widgets-input-padding: 4px;
  --jp-widgets-radio-item-height-adjustment: 8px;
  --jp-widgets-radio-item-height: calc(
    var(--jp-widgets-inline-height) -
      var(--jp-widgets-radio-item-height-adjustment)
  );
  --jp-widgets-slider-track-thickness: 4px;
  --jp-widgets-slider-border-width: var(--jp-widgets-border-width);
  --jp-widgets-slider-handle-size: 16px;
  --jp-widgets-slider-handle-border-color: var(--jp-border-color1);
  --jp-widgets-slider-handle-background-color: var(--jp-layout-color1);
  --jp-widgets-slider-active-handle-color: var(--jp-brand-color1);
  --jp-widgets-menu-item-height: 24px;
  --jp-widgets-dropdown-arrow: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --jp-widgets-input-color: var(--jp-ui-font-color1);
  --jp-widgets-input-background-color: var(--jp-layout-color1);
  --jp-widgets-input-border-color: var(--jp-border-color1);
  --jp-widgets-input-focus-border-color: var(--jp-brand-color2);
  --jp-widgets-input-border-width: var(--jp-widgets-border-width);
  --jp-widgets-disabled-opacity: 0.6;

  /* From Material Design Lite */
  --md-shadow-key-umbra-opacity: 0.2;
  --md-shadow-key-penumbra-opacity: 0.14;
  --md-shadow-ambient-shadow-opacity: 0.12;
}

.jupyter-widgets {
  margin: var(--jp-widgets-margin);
  box-sizing: border-box;
  color: var(--jp-widgets-color);
  overflow: visible;
}

.jp-Output-result > .jupyter-widgets {
  margin-left: 0;
  margin-right: 0;
}

/* vbox and hbox */

/* <DEPRECATED> */
.widget-inline-hbox, /* </DEPRECATED> */
 .jupyter-widget-inline-hbox {
  /* Horizontal widgets */
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

/* <DEPRECATED> */
.widget-inline-vbox, /* </DEPRECATED> */
 .jupyter-widget-inline-vbox {
  /* Vertical Widgets */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* <DEPRECATED> */
.widget-box, /* </DEPRECATED> */
.jupyter-widget-box {
  box-sizing: border-box;
  display: flex;
  margin: 0;
  overflow: auto;
}

/* <DEPRECATED> */
.widget-gridbox, /* </DEPRECATED> */
.jupyter-widget-gridbox {
  box-sizing: border-box;
  display: grid;
  margin: 0;
  overflow: auto;
}

/* <DEPRECATED> */
.widget-hbox, /* </DEPRECATED> */
.jupyter-widget-hbox {
  flex-direction: row;
}

/* <DEPRECATED> */
.widget-vbox, /* </DEPRECATED> */
.jupyter-widget-vbox {
  flex-direction: column;
}

/* General Tags Styling */

.jupyter-widget-tagsinput {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  overflow: auto;

  cursor: text;
}

.jupyter-widget-tag {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: var(--jp-widgets-font-size);

  height: calc(var(--jp-widgets-inline-height) - 2px);
  border: 0px solid;
  line-height: calc(var(--jp-widgets-inline-height) - 2px);
  box-shadow: none;

  color: var(--jp-ui-font-color1);
  background-color: var(--jp-layout-color2);
  border-color: var(--jp-border-color2);
  border: none;
  user-select: none;

  cursor: grab;
  transition: margin-left 200ms;
  margin: 1px 1px 1px 1px;
}

.jupyter-widget-tag.mod-active {
  /* MD Lite 4dp shadow */
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),
    0 1px 10px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity)),
    0 2px 4px -1px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity));
  color: var(--jp-ui-font-color1);
  background-color: var(--jp-layout-color3);
}

.jupyter-widget-colortag {
  color: var(--jp-inverse-ui-font-color1);
}

.jupyter-widget-colortag.mod-active {
  color: var(--jp-inverse-ui-font-color0);
}

.jupyter-widget-taginput {
  color: var(--jp-ui-font-color0);
  background-color: var(--jp-layout-color0);

  cursor: text;
  text-align: left;
}

.jupyter-widget-taginput:focus {
  outline: none;
}

.jupyter-widget-tag-close {
  margin-left: var(--jp-widgets-inline-margin);
  padding: 2px 0px 2px 2px;
}

.jupyter-widget-tag-close:hover {
  cursor: pointer;
}

/* Tag "Primary" Styling */

.jupyter-widget-tag.mod-primary {
  color: var(--jp-inverse-ui-font-color1);
  background-color: var(--jp-brand-color1);
}

.jupyter-widget-tag.mod-primary.mod-active {
  color: var(--jp-inverse-ui-font-color0);
  background-color: var(--jp-brand-color0);
}

/* Tag "Success" Styling */

.jupyter-widget-tag.mod-success {
  color: var(--jp-inverse-ui-font-color1);
  background-color: var(--jp-success-color1);
}

.jupyter-widget-tag.mod-success.mod-active {
  color: var(--jp-inverse-ui-font-color0);
  background-color: var(--jp-success-color0);
}

/* Tag "Info" Styling */

.jupyter-widget-tag.mod-info {
  color: var(--jp-inverse-ui-font-color1);
  background-color: var(--jp-info-color1);
}

.jupyter-widget-tag.mod-info.mod-active {
  color: var(--jp-inverse-ui-font-color0);
  background-color: var(--jp-info-color0);
}

/* Tag "Warning" Styling */

.jupyter-widget-tag.mod-warning {
  color: var(--jp-inverse-ui-font-color1);
  background-color: var(--jp-warn-color1);
}

.jupyter-widget-tag.mod-warning.mod-active {
  color: var(--jp-inverse-ui-font-color0);
  background-color: var(--jp-warn-color0);
}

/* Tag "Danger" Styling */

.jupyter-widget-tag.mod-danger {
  color: var(--jp-inverse-ui-font-color1);
  background-color: var(--jp-error-color1);
}

.jupyter-widget-tag.mod-danger.mod-active {
  color: var(--jp-inverse-ui-font-color0);
  background-color: var(--jp-error-color0);
}

/* General Button Styling */

.jupyter-button {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: var(--jp-widgets-font-size);
  cursor: pointer;

  height: var(--jp-widgets-inline-height);
  border: 0px solid;
  line-height: var(--jp-widgets-inline-height);
  box-shadow: none;

  color: var(--jp-ui-font-color1);
  background-color: var(--jp-layout-color2);
  border-color: var(--jp-border-color2);
  border: none;
  user-select: none;
}

.jupyter-button i.fa {
  margin-right: var(--jp-widgets-inline-margin);
  pointer-events: none;
}

.jupyter-button:empty:before {
  content: '\\200b'; /* zero-width space */
}

.jupyter-widgets.jupyter-button:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

.jupyter-button i.fa.center {
  margin-right: 0;
}

.jupyter-button:hover:enabled,
.jupyter-button:focus:enabled {
  /* MD Lite 2dp shadow */
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),
    0 3px 1px -2px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity)),
    0 1px 5px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity));
}

.jupyter-button:active,
.jupyter-button.mod-active {
  /* MD Lite 4dp shadow */
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),
    0 1px 10px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity)),
    0 2px 4px -1px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity));
  color: var(--jp-ui-font-color1);
  background-color: var(--jp-layout-color3);
}

.jupyter-button:focus:enabled {
  outline: 1px solid var(--jp-widgets-input-focus-border-color);
}

/* Button "Primary" Styling */

.jupyter-button.mod-primary {
  color: var(--jp-ui-inverse-font-color1);
  background-color: var(--jp-brand-color1);
}

.jupyter-button.mod-primary.mod-active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-brand-color0);
}

.jupyter-button.mod-primary:active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-brand-color0);
}

/* Button "Success" Styling */

.jupyter-button.mod-success {
  color: var(--jp-ui-inverse-font-color1);
  background-color: var(--jp-success-color1);
}

.jupyter-button.mod-success.mod-active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-success-color0);
}

.jupyter-button.mod-success:active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-success-color0);
}

/* Button "Info" Styling */

.jupyter-button.mod-info {
  color: var(--jp-ui-inverse-font-color1);
  background-color: var(--jp-info-color1);
}

.jupyter-button.mod-info.mod-active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-info-color0);
}

.jupyter-button.mod-info:active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-info-color0);
}

/* Button "Warning" Styling */

.jupyter-button.mod-warning {
  color: var(--jp-ui-inverse-font-color1);
  background-color: var(--jp-warn-color1);
}

.jupyter-button.mod-warning.mod-active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-warn-color0);
}

.jupyter-button.mod-warning:active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-warn-color0);
}

/* Button "Danger" Styling */

.jupyter-button.mod-danger {
  color: var(--jp-ui-inverse-font-color1);
  background-color: var(--jp-error-color1);
}

.jupyter-button.mod-danger.mod-active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-error-color0);
}

.jupyter-button.mod-danger:active {
  color: var(--jp-ui-inverse-font-color0);
  background-color: var(--jp-error-color0);
}

/* Widget Button, Widget Toggle Button, Widget Upload */

/* <DEPRECATED> */
.widget-button, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-toggle-button, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-upload, /* </DEPRECATED> */
.jupyter-widget-button,
.jupyter-widget-toggle-button,
.jupyter-widget-upload {
  width: var(--jp-widgets-inline-width-short);
}

/* Widget Label Styling */

/* Override Bootstrap label css */
.jupyter-widgets label {
  margin-bottom: initial;
}

/* <DEPRECATED> */
.widget-label-basic, /* </DEPRECATED> */
.jupyter-widget-label-basic {
  /* Basic Label */
  color: var(--jp-widgets-label-color);
  font-size: var(--jp-widgets-font-size);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-label, /* </DEPRECATED> */
.jupyter-widget-label {
  /* Label */
  color: var(--jp-widgets-label-color);
  font-size: var(--jp-widgets-font-size);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-inline-hbox .widget-label, /* </DEPRECATED> */
.jupyter-widget-inline-hbox .jupyter-widget-label {
  /* Horizontal Widget Label */
  color: var(--jp-widgets-label-color);
  text-align: right;
  margin-right: calc(var(--jp-widgets-inline-margin) * 2);
  width: var(--jp-widgets-inline-label-width);
  flex-shrink: 0;
}

/* <DEPRECATED> */
.widget-inline-vbox .widget-label, /* </DEPRECATED> */
.jupyter-widget-inline-vbox .jupyter-widget-label {
  /* Vertical Widget Label */
  color: var(--jp-widgets-label-color);
  text-align: center;
  line-height: var(--jp-widgets-inline-height);
}

/* Widget Readout Styling */

/* <DEPRECATED> */
.widget-readout, /* </DEPRECATED> */
.jupyter-widget-readout {
  color: var(--jp-widgets-readout-color);
  font-size: var(--jp-widgets-font-size);
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}

/* <DEPRECATED> */
.widget-readout.overflow, /* </DEPRECATED> */
.jupyter-widget-readout.overflow {
  /* Overflowing Readout */

  /* From Material Design Lite
        shadow-key-umbra-opacity: 0.2;
        shadow-key-penumbra-opacity: 0.14;
        shadow-ambient-shadow-opacity: 0.12;
     */
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2),
    0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2),
    0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

/* <DEPRECATED> */
.widget-inline-hbox .widget-readout, /* </DEPRECATED> */
.jupyter-widget-inline-hbox .jupyter-widget-readout {
  /* Horizontal Readout */
  text-align: center;
  max-width: var(--jp-widgets-inline-width-short);
  min-width: var(--jp-widgets-inline-width-tiny);
  margin-left: var(--jp-widgets-inline-margin);
}

/* <DEPRECATED> */
.widget-inline-vbox .widget-readout, /* </DEPRECATED> */
.jupyter-widget-inline-vbox .jupyter-widget-readout {
  /* Vertical Readout */
  margin-top: var(--jp-widgets-inline-margin);
  /* as wide as the widget */
  width: inherit;
}

/* Widget Checkbox Styling */

/* <DEPRECATED> */
.widget-checkbox, /* </DEPRECATED> */
.jupyter-widget-checkbox {
  width: var(--jp-widgets-inline-width);
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-checkbox input[type='checkbox'], /* </DEPRECATED> */
.jupyter-widget-checkbox input[type='checkbox'] {
  margin: 0px calc(var(--jp-widgets-inline-margin) * 2) 0px 0px;
  line-height: var(--jp-widgets-inline-height);
  font-size: large;
  flex-grow: 1;
  flex-shrink: 0;
  align-self: center;
}

/* Widget Valid Styling */

/* <DEPRECATED> */
.widget-valid, /* </DEPRECATED> */
.jupyter-widget-valid {
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
  width: var(--jp-widgets-inline-width-short);
  font-size: var(--jp-widgets-font-size);
}

/* <DEPRECATED> */
.widget-valid i, /* </DEPRECATED> */
.jupyter-widget-valid i {
  line-height: var(--jp-widgets-inline-height);
  margin-right: var(--jp-widgets-inline-margin);
  margin-left: var(--jp-widgets-inline-margin);
}

/* <DEPRECATED> */
.widget-valid.mod-valid i, /* </DEPRECATED> */
.jupyter-widget-valid.mod-valid i {
  color: green;
}

/* <DEPRECATED> */
.widget-valid.mod-invalid i, /* </DEPRECATED> */
.jupyter-widget-valid.mod-invalid i {
  color: red;
}

/* <DEPRECATED> */
.widget-valid.mod-valid .widget-valid-readout, /* </DEPRECATED> */
.jupyter-widget-valid.mod-valid .jupyter-widget-valid-readout {
  display: none;
}

/* Widget Text and TextArea Styling */

/* <DEPRECATED> */
.widget-textarea, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text, /* </DEPRECATED> */
.jupyter-widget-textarea,
.jupyter-widget-text {
  width: var(--jp-widgets-inline-width);
}

/* <DEPRECATED> */
.widget-text input[type='text'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='number'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */
.jupyter-widget-text input[type='text'],
.jupyter-widget-text input[type='number'],
.jupyter-widget-text input[type='password'] {
  height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-text input[type='text']:disabled, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='number']:disabled, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='password']:disabled, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-textarea textarea:disabled, /* </DEPRECATED> */
.jupyter-widget-text input[type='text']:disabled,
.jupyter-widget-text input[type='number']:disabled,
.jupyter-widget-text input[type='password']:disabled,
.jupyter-widget-textarea textarea:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* <DEPRECATED> */
.widget-text input[type='text'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='number'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-textarea textarea, /* </DEPRECATED> */
.jupyter-widget-text input[type='text'],
.jupyter-widget-text input[type='number'],
.jupyter-widget-text input[type='password'],
.jupyter-widget-textarea textarea {
  box-sizing: border-box;
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  background-color: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  font-size: var(--jp-widgets-font-size);
  flex-grow: 1;
  min-width: 0; /* This makes it possible for the flexbox to shrink this input */
  flex-shrink: 1;
  outline: none !important;
}

/* <DEPRECATED> */
.widget-text input[type='text'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-textarea textarea, /* </DEPRECATED> */
.jupyter-widget-text input[type='text'],
.jupyter-widget-text input[type='password'],
.jupyter-widget-textarea textarea {
  padding: var(--jp-widgets-input-padding)
    calc(var(--jp-widgets-input-padding) * 2);
}

/* <DEPRECATED> */
.widget-text input[type='number'], /* </DEPRECATED> */
.jupyter-widget-text input[type='number'] {
  padding: var(--jp-widgets-input-padding) 0 var(--jp-widgets-input-padding)
    calc(var(--jp-widgets-input-padding) * 2);
}

/* <DEPRECATED> */
.widget-textarea textarea, /* </DEPRECATED> */
.jupyter-widget-textarea textarea {
  height: inherit;
  width: inherit;
}

/* <DEPRECATED> */
.widget-text input:focus, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-textarea textarea:focus, /* </DEPRECATED> */
.jupyter-widget-text input:focus,
.jupyter-widget-textarea textarea:focus {
  border-color: var(--jp-widgets-input-focus-border-color);
}

/* Horizontal Slider */
/* <DEPRECATED> */
.widget-hslider, /* </DEPRECATED> */
.jupyter-widget-hslider {
  width: var(--jp-widgets-inline-width);
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);

  /* Override the align-items baseline. This way, the description and readout
    still seem to align their baseline properly, and we don't have to have
    align-self: stretch in the .slider-container. */
  align-items: center;
}

/* <DEPRECATED> */
.widgets-slider .slider-container, /* </DEPRECATED> */
.jupyter-widgets-slider .slider-container {
  overflow: visible;
}

/* <DEPRECATED> */
.widget-hslider .slider-container, /* </DEPRECATED> */
.jupyter-widget-hslider .slider-container {
  margin-left: calc(
    var(--jp-widgets-slider-handle-size) / 2 - 2 *
      var(--jp-widgets-slider-border-width)
  );
  margin-right: calc(
    var(--jp-widgets-slider-handle-size) / 2 - 2 *
      var(--jp-widgets-slider-border-width)
  );
  flex: 1 1 var(--jp-widgets-inline-width-short);
}

/* Vertical Slider */

/* <DEPRECATED> */
.widget-vbox .widget-label, /* </DEPRECATED> */
.jupyter-widget-vbox .jupyter-widget-label {
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-vslider, /* </DEPRECATED> */
.jupyter-widget-vslider {
  /* Vertical Slider */
  height: var(--jp-widgets-vertical-height);
  width: var(--jp-widgets-inline-width-tiny);
}

/* <DEPRECATED> */
.widget-vslider .slider-container, /* </DEPRECATED> */
.jupyter-widget-vslider .slider-container {
  flex: 1 1 var(--jp-widgets-inline-width-short);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: calc(
    var(--jp-widgets-slider-handle-size) / 2 - 2 *
      var(--jp-widgets-slider-border-width)
  );
  margin-top: calc(
    var(--jp-widgets-slider-handle-size) / 2 - 2 *
      var(--jp-widgets-slider-border-width)
  );
  display: flex;
  flex-direction: column;
}

/* Widget Progress Styling */

.progress-bar {
  -webkit-transition: none;
  -moz-transition: none;
  -ms-transition: none;
  -o-transition: none;
  transition: none;
}

.progress-bar {
  height: var(--jp-widgets-inline-height);
}

.progress-bar {
  background-color: var(--jp-brand-color1);
}

.progress-bar-success {
  background-color: var(--jp-success-color1);
}

.progress-bar-info {
  background-color: var(--jp-info-color1);
}

.progress-bar-warning {
  background-color: var(--jp-warn-color1);
}

.progress-bar-danger {
  background-color: var(--jp-error-color1);
}

.progress {
  background-color: var(--jp-layout-color2);
  border: none;
  box-shadow: none;
}

/* Horisontal Progress */

/* <DEPRECATED> */
.widget-hprogress, /* </DEPRECATED> */
.jupyter-widget-hprogress {
  /* Progress Bar */
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
  width: var(--jp-widgets-inline-width);
  align-items: center;
}

/* <DEPRECATED> */
.widget-hprogress .progress, /* </DEPRECATED> */
.jupyter-widget-hprogress .progress {
  flex-grow: 1;
  margin-top: var(--jp-widgets-input-padding);
  margin-bottom: var(--jp-widgets-input-padding);
  align-self: stretch;
  /* Override bootstrap style */
  height: initial;
}

/* Vertical Progress */

/* <DEPRECATED> */
.widget-vprogress, /* </DEPRECATED> */
.jupyter-widget-vprogress {
  height: var(--jp-widgets-vertical-height);
  width: var(--jp-widgets-inline-width-tiny);
}

/* <DEPRECATED> */
.widget-vprogress .progress, /* </DEPRECATED> */
.jupyter-widget-vprogress .progress {
  flex-grow: 1;
  width: var(--jp-widgets-progress-thickness);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
}

/* Select Widget Styling */

/* <DEPRECATED> */
.widget-dropdown, /* </DEPRECATED> */
.jupyter-widget-dropdown {
  height: var(--jp-widgets-inline-height);
  width: var(--jp-widgets-inline-width);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-dropdown > select, /* </DEPRECATED> */
.jupyter-widget-dropdown > select {
  padding-right: 20px;
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  border-radius: 0;
  height: inherit;
  flex: 1 1 var(--jp-widgets-inline-width-short);
  min-width: 0; /* This makes it possible for the flexbox to shrink this input */
  box-sizing: border-box;
  outline: none !important;
  box-shadow: none;
  background-color: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  font-size: var(--jp-widgets-font-size);
  vertical-align: top;
  padding-left: calc(var(--jp-widgets-input-padding) * 2);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: right center;
  background-image: var(--jp-widgets-dropdown-arrow);
}
/* <DEPRECATED> */
.widget-dropdown > select:focus, /* </DEPRECATED> */
.jupyter-widget-dropdown > select:focus {
  border-color: var(--jp-widgets-input-focus-border-color);
}

/* <DEPRECATED> */
.widget-dropdown > select:disabled, /* </DEPRECATED> */
.jupyter-widget-dropdown > select:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* To disable the dotted border in Firefox around select controls.
   See http://stackoverflow.com/a/18853002 */
/* <DEPRECATED> */
.widget-dropdown > select:-moz-focusring, /* </DEPRECATED> */
.jupyter-widget-dropdown > select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

/* Select and SelectMultiple */

/* <DEPRECATED> */
.widget-select, /* </DEPRECATED> */
.jupyter-widget-select {
  width: var(--jp-widgets-inline-width);
  line-height: var(--jp-widgets-inline-height);

  /* Because Firefox defines the baseline of a select as the bottom of the
    control, we align the entire control to the top and add padding to the
    select to get an approximate first line baseline alignment. */
  align-items: flex-start;
}

/* <DEPRECATED> */
.widget-select > select, /* </DEPRECATED> */
.jupyter-widget-select > select {
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  background-color: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  font-size: var(--jp-widgets-font-size);
  flex: 1 1 var(--jp-widgets-inline-width-short);
  outline: none !important;
  overflow: auto;
  height: inherit;

  /* Because Firefox defines the baseline of a select as the bottom of the
    control, we align the entire control to the top and add padding to the
    select to get an approximate first line baseline alignment. */
  padding-top: 5px;
}

/* <DEPRECATED> */
.widget-select > select:focus, /* </DEPRECATED> */
.jupyter-widget-select > select:focus {
  border-color: var(--jp-widgets-input-focus-border-color);
}

.wiget-select > select > option,
.jupyter-wiget-select > select > option {
  padding-left: var(--jp-widgets-input-padding);
  line-height: var(--jp-widgets-inline-height);
  /* line-height doesn't work on some browsers for select options */
  padding-top: calc(
    var(--jp-widgets-inline-height) - var(--jp-widgets-font-size) / 2
  );
  padding-bottom: calc(
    var(--jp-widgets-inline-height) - var(--jp-widgets-font-size) / 2
  );
}

/* Toggle Buttons Styling */

/* <DEPRECATED> */
.widget-toggle-buttons, /* </DEPRECATED> */
.jupyter-widget-toggle-buttons {
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-toggle-buttons .widget-toggle-button, /* </DEPRECATED> */
.jupyter-widget-toggle-buttons .jupyter-widget-toggle-button {
  margin-left: var(--jp-widgets-margin);
  margin-right: var(--jp-widgets-margin);
}

/* <DEPRECATED> */
.widget-toggle-buttons .jupyter-button:disabled, /* </DEPRECATED> */
.jupyter-widget-toggle-buttons .jupyter-button:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* Radio Buttons Styling */

/* <DEPRECATED> */
.widget-radio, /* </DEPRECATED> */
.jupyter-widget-radio {
  width: var(--jp-widgets-inline-width);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-radio-box, /* </DEPRECATED> */
.jupyter-widget-radio-box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  flex-grow: 1;
  margin-bottom: var(--jp-widgets-radio-item-height-adjustment);
}

/* <DEPRECATED> */
.widget-radio-box-vertical, /* </DEPRECATED> */
.jupyter-widget-radio-box-vertical {
  flex-direction: column;
}

/* <DEPRECATED> */
.widget-radio-box-horizontal, /* </DEPRECATED> */
.jupyter-widget-radio-box-horizontal {
  flex-direction: row;
}

/* <DEPRECATED> */
.widget-radio-box label, /* </DEPRECATED> */
.jupyter-widget-radio-box label {
  height: var(--jp-widgets-radio-item-height);
  line-height: var(--jp-widgets-radio-item-height);
  font-size: var(--jp-widgets-font-size);
}

.widget-radio-box-horizontal label,
.jupyter-widget-radio-box-horizontal label {
  margin: 0 calc(var(--jp-widgets-input-padding) * 2) 0 0;
}

/* <DEPRECATED> */
.widget-radio-box input, /* </DEPRECATED> */
.jupyter-widget-radio-box input {
  height: var(--jp-widgets-radio-item-height);
  line-height: var(--jp-widgets-radio-item-height);
  margin: 0 calc(var(--jp-widgets-input-padding) * 2) 0 1px;
  float: left;
}

/* Color Picker Styling */

/* <DEPRECATED> */
.widget-colorpicker, /* </DEPRECATED> */
.jupyter-widget-colorpicker {
  width: var(--jp-widgets-inline-width);
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-colorpicker > .widget-colorpicker-input, /* </DEPRECATED> */
.jupyter-widget-colorpicker > .jupyter-widget-colorpicker-input {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: var(--jp-widgets-inline-width-tiny);
}

/* <DEPRECATED> */
.widget-colorpicker input[type='color'], /* </DEPRECATED> */
.jupyter-widget-colorpicker input[type='color'] {
  width: var(--jp-widgets-inline-height);
  height: var(--jp-widgets-inline-height);
  padding: 0 2px; /* make the color square actually square on Chrome on OS X */
  background: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  border-left: none;
  flex-grow: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  align-self: stretch;
  outline: none !important;
}

/* <DEPRECATED> */
.widget-colorpicker.concise input[type='color'], /* </DEPRECATED> */
.jupyter-widget-colorpicker.concise input[type='color'] {
  border-left: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
}

/* <DEPRECATED> */
.widget-colorpicker input[type='color']:focus, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-colorpicker input[type='text']:focus, /* </DEPRECATED> */
.jupyter-widget-colorpicker input[type='color']:focus,
.jupyter-widget-colorpicker input[type='text']:focus {
  border-color: var(--jp-widgets-input-focus-border-color);
}

/* <DEPRECATED> */
.widget-colorpicker input[type='text'], /* </DEPRECATED> */
.jupyter-widget-colorpicker input[type='text'] {
  flex-grow: 1;
  outline: none !important;
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
  background: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  font-size: var(--jp-widgets-font-size);
  padding: var(--jp-widgets-input-padding)
    calc(var(--jp-widgets-input-padding) * 2);
  min-width: 0; /* This makes it possible for the flexbox to shrink this input */
  flex-shrink: 1;
  box-sizing: border-box;
}

/* <DEPRECATED> */
.widget-colorpicker input[type='text']:disabled, /* </DEPRECATED> */
.jupyter-widget-colorpicker input[type='text']:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* Date Picker Styling */

/* <DEPRECATED> */
.widget-datepicker, /* </DEPRECATED> */
.jupyter-widget-datepicker {
  width: var(--jp-widgets-inline-width);
  height: var(--jp-widgets-inline-height);
  line-height: var(--jp-widgets-inline-height);
}

/* <DEPRECATED> */
.widget-datepicker input[type='date'], /* </DEPRECATED> */
.jupyter-widget-datepicker input[type='date'] {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0; /* This makes it possible for the flexbox to shrink this input */
  outline: none !important;
  height: var(--jp-widgets-inline-height);
  border: var(--jp-widgets-input-border-width) solid
    var(--jp-widgets-input-border-color);
  background-color: var(--jp-widgets-input-background-color);
  color: var(--jp-widgets-input-color);
  font-size: var(--jp-widgets-font-size);
  padding: var(--jp-widgets-input-padding)
    calc(var(--jp-widgets-input-padding) * 2);
  box-sizing: border-box;
}

/* <DEPRECATED> */
.widget-datepicker input[type='date']:focus, /* </DEPRECATED> */
.jupyter-widget-datepicker input[type='date']:focus {
  border-color: var(--jp-widgets-input-focus-border-color);
}

/* <DEPRECATED> */
.widget-datepicker input[type='date']:invalid, /* </DEPRECATED> */
.jupyter-widget-datepicker input[type='date']:invalid {
  border-color: var(--jp-warn-color1);
}

/* <DEPRECATED> */
.widget-datepicker input[type='date']:disabled, /* </DEPRECATED> */
.jupyter-widget-datepicker input[type='date']:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* Play Widget */

/* <DEPRECATED> */
.widget-play, /* </DEPRECATED> */
.jupyter-widget-play {
  width: var(--jp-widgets-inline-width-short);
  display: flex;
  align-items: stretch;
}

/* <DEPRECATED> */
.widget-play .jupyter-button, /* </DEPRECATED> */
.jupyter-widget-play .jupyter-button {
  flex-grow: 1;
  height: auto;
}

/* <DEPRECATED> */
.widget-play .jupyter-button:disabled, /* </DEPRECATED> */
.jupyter-widget-play .jupyter-button:disabled {
  opacity: var(--jp-widgets-disabled-opacity);
}

/* Tab Widget */

/* <DEPRECATED> */
.jupyter-widgets.widget-tab, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab {
  display: flex;
  flex-direction: column;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar {
  /* Necessary so that a tab can be shifted down to overlay the border of the box below. */
  overflow-x: visible;
  overflow-y: visible;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar > .p-TabBar-content, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar > .p-TabBar-content, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar > .lm-TabBar-content {
  /* Make sure that the tab grows from bottom up */
  align-items: flex-end;
  min-width: 0;
  min-height: 0;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .widget-tab-contents, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .widget-tab-contents {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  background: var(--jp-layout-color1);
  color: var(--jp-ui-font-color1);
  border: var(--jp-border-width) solid var(--jp-border-color1);
  padding: var(--jp-widgets-container-padding);
  flex-grow: 1;
  overflow: auto;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar {
  font: var(--jp-widgets-font-size) Helvetica, Arial, sans-serif;
  min-height: calc(
    var(--jp-widgets-horizontal-tab-height) + var(--jp-border-width)
  );
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab {
  flex: 0 1 var(--jp-widgets-horizontal-tab-width);
  min-width: 35px;
  min-height: calc(
    var(--jp-widgets-horizontal-tab-height) + var(--jp-border-width)
  );
  line-height: var(--jp-widgets-horizontal-tab-height);
  margin-left: calc(-1 * var(--jp-border-width));
  padding: 0px 10px;
  background: var(--jp-layout-color2);
  color: var(--jp-ui-font-color2);
  border: var(--jp-border-width) solid var(--jp-border-color1);
  border-bottom: none;
  position: relative;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab.lm-mod-current {
  color: var(--jp-ui-font-color0);
  /* We want the background to match the tab content background */
  background: var(--jp-layout-color1);
  min-height: calc(
    var(--jp-widgets-horizontal-tab-height) + 2 * var(--jp-border-width)
  );
  transform: translateY(var(--jp-border-width));
  overflow: visible;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current:before, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current:before, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab.lm-mod-current:before {
  position: absolute;
  top: calc(-1 * var(--jp-border-width));
  left: calc(-1 * var(--jp-border-width));
  content: '';
  height: var(--jp-widgets-horizontal-tab-top-border);
  width: calc(100% + 2 * var(--jp-border-width));
  background: var(--jp-brand-color1);
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab:first-child, /* </DEPRECATED> */
/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab:first-child, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab:first-child {
  margin-left: 0;
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab
  > .p-TabBar
  .p-TabBar-tab:hover:not(.p-mod-current),
/* </DEPRECATED> */
/* <DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab
  > .p-TabBar
  .p-TabBar-tab:hover:not(.p-mod-current),
/* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab
  > .lm-TabBar
  .lm-TabBar-tab:hover:not(.lm-mod-current) {
  background: var(--jp-layout-color1);
  color: var(--jp-ui-font-color1);
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab
  > .p-TabBar
  .p-mod-closable
  > .p-TabBar-tabCloseIcon,
/* </DEPRECATED> */
/* <DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab
> .p-TabBar
.p-mod-closable
> .p-TabBar-tabCloseIcon,
/* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab
  > .lm-TabBar
  .lm-mod-closable
  > .lm-TabBar-tabCloseIcon {
  margin-left: 4px;
}

/* This font-awesome strategy may not work across FA4 and FA5, but we don't
actually support closable tabs, so it really doesn't matter */
/* <DEPRECATED> */
.jupyter-widgets.widget-tab
  > .p-TabBar
  .p-mod-closable
  > .p-TabBar-tabCloseIcon:before,
/* </DEPRECATED> */
/* <DEPRECATED> */
.jupyter-widgets.jupyter-widget-widget-tab
> .p-TabBar
.p-mod-closable
> .p-TabBar-tabCloseIcon:before,
/* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab
  > .lm-TabBar
  .lm-mod-closable
  > .lm-TabBar-tabCloseIcon:before {
  font-family: FontAwesome;
  content: '\\f00d'; /* close */
}

/* <DEPRECATED> */
.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabIcon, /* </DEPRECATED> */
/* <DEPRECATED> */ .jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabLabel, /* </DEPRECATED> */
/* <DEPRECATED> */ .jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabCloseIcon, /* </DEPRECATED> */
/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabIcon, /* </DEPRECATED> */
/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabLabel, /* </DEPRECATED> */
/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabCloseIcon, /* </DEPRECATED> */
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabIcon,
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabLabel,
.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabCloseIcon {
  line-height: var(--jp-widgets-horizontal-tab-height);
}

/* Accordion Widget */

.jupyter-widget-Collapse {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.jupyter-widget-Collapse-header {
  padding: var(--jp-widgets-input-padding);
  cursor: pointer;
  color: var(--jp-ui-font-color2);
  background-color: var(--jp-layout-color2);
  border: var(--jp-widgets-border-width) solid var(--jp-border-color1);
  padding: calc(var(--jp-widgets-container-padding) * 2 / 3)
    var(--jp-widgets-container-padding);
  font-weight: bold;
}

.jupyter-widget-Collapse-header:hover {
  background-color: var(--jp-layout-color1);
  color: var(--jp-ui-font-color1);
}

.jupyter-widget-Collapse-open > .jupyter-widget-Collapse-header {
  background-color: var(--jp-layout-color1);
  color: var(--jp-ui-font-color0);
  cursor: default;
  border-bottom: none;
}

.jupyter-widget-Collapse-contents {
  padding: var(--jp-widgets-container-padding);
  background-color: var(--jp-layout-color1);
  color: var(--jp-ui-font-color1);
  border-left: var(--jp-widgets-border-width) solid var(--jp-border-color1);
  border-right: var(--jp-widgets-border-width) solid var(--jp-border-color1);
  border-bottom: var(--jp-widgets-border-width) solid var(--jp-border-color1);
  overflow: auto;
}

.jupyter-widget-Accordion {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.jupyter-widget-Accordion .jupyter-widget-Collapse {
  margin-bottom: 0;
}

.jupyter-widget-Accordion .jupyter-widget-Collapse + .jupyter-widget-Collapse {
  margin-top: 4px;
}

/* HTML widget */

/* <DEPRECATED> */
.widget-html, /* </DEPRECATED> */
/* <DEPRECATED> */ .widget-htmlmath, /* </DEPRECATED> */
.jupyter-widget-html,
.jupyter-widget-htmlmath {
  font-size: var(--jp-widgets-font-size);
}

/* <DEPRECATED> */
.widget-html > .widget-html-content, /* </DEPRECATED> */
/* <DEPRECATED> */.widget-htmlmath > .widget-html-content, /* </DEPRECATED> */
.jupyter-widget-html > .jupyter-widget-html-content,
.jupyter-widget-htmlmath > .jupyter-widget-html-content {
  /* Fill out the area in the HTML widget */
  align-self: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  /* Makes sure the baseline is still aligned with other elements */
  line-height: var(--jp-widgets-inline-height);
  /* Make it possible to have absolutely-positioned elements in the html */
  position: relative;
}

/* Image widget  */

/* <DEPRECATED> */
.widget-image, /* </DEPRECATED> */
.jupyter-widget-image {
  max-width: 100%;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/controls/css/widgets-base.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;;;;EAIE;;AAKF;EACE,iDAAiD;EACjD,iDAAiD;EACjD,mDAAmD;EACnD,+CAA+C;EAC/C,wBAAwB;EACxB,gCAAgC;EAChC,gCAAgC;EAChC;;GAEC;EACD;;GAEC;EACD,+BAA+B,EAAE,mCAAmC;EACpE,qCAAqC;EACrC,iDAAiD;EACjD,mCAAmC;EACnC,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,oCAAoC;EACpC,+BAA+B;EAC/B,8CAA8C;EAC9C;;;GAGC;EACD,wCAAwC;EACxC,gEAAgE;EAChE,qCAAqC;EACrC,gEAAgE;EAChE,oEAAoE;EACpE,+DAA+D;EAC/D,mCAAmC;EACnC,oEAA4uB;EAC5uB,kDAAkD;EAClD,4DAA4D;EAC5D,wDAAwD;EACxD,6DAA6D;EAC7D,+DAA+D;EAC/D,kCAAkC;;EAElC,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;;AAElB,iBAAiB;AACjB;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;AACxB;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;;EAEd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;;EAEtC,mDAAmD;EACnD,iBAAiB;EACjB,wDAAwD;EACxD,gBAAgB;;EAEhB,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;;EAEjB,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;;oEAEkE;EAClE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;;EAEzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;;AAE1B;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,0BAA0B;;AAE1B;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,uBAAuB;;AAEvB;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,0BAA0B;;AAE1B;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,yBAAyB;;AAEzB;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;;EAEf,uCAAuC;EACvC,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;;EAEhB,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB;;sEAEoE;AACtE;;AAEA;;EAEE,uBAAuB;EACvB;;oEAEkE;EAClE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,6BAA6B;;AAE7B;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,6BAA6B;;AAE7B;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,0BAA0B;;AAE1B;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,6BAA6B;;AAE7B;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,4BAA4B;;AAE5B;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,uDAAuD;;AAEvD,iBAAiB;AACjB;;;;;;EAME,2CAA2C;AAC7C;;AAEA,yBAAyB;;AAEzB,iCAAiC;AACjC;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,UAAU;EACV,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,4BAA4B;EAC5B,oCAAoC;EACpC,iBAAiB;EACjB,uDAAuD;EACvD,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,2BAA2B;;AAE3B,iBAAiB;AACjB;;EAEE,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;EAEE,wBAAwB;;EAExB;;;;MAII;EACJ;uEACqE;;EAErE;uEACqE;;EAErE;mCACiC;AACnC;;AAEA,iBAAiB;AACjB;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;EAC/C,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,6DAA6D;EAC7D,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;;AAEzB,iBAAiB;AACjB;;EAEE,uCAAuC;EACvC,4CAA4C;EAC5C,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;;EAEE,4CAA4C;EAC5C,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;AACd;;AAEA,iBAAiB;AACjB;;EAEE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;AACf;;AAEA,qCAAqC;;AAErC,iBAAiB;AACjB;;;;EAIE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;;;;;;EAME,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;;;;;;;;EAQE,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;;;;;;;;EAQE,sBAAsB;EACtB;wCACsC;EACtC,0DAA0D;EAC1D,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,YAAY,EAAE,gEAAgE;EAC9E,cAAc;EACd,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;;;;;;EAME;6CAC2C;AAC7C;;AAEA,iBAAiB;AACjB;;EAEE;6CAC2C;AAC7C;;AAEA,iBAAiB;AACjB;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;;;EAIE,wDAAwD;AAC1D;;AAEA,sBAAsB;AACtB,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,4CAA4C;;EAE5C;;mDAEiD;EACjD,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;EAEE;;;GAGC;EACD;;;GAGC;EACD,8CAA8C;AAChD;;AAEA,oBAAoB;;AAEpB,iBAAiB;AACjB;;EAEE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,oBAAoB;EACpB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;;EAEE,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD,aAAa;EACb,sBAAsB;AACxB;;AAEA,4BAA4B;;AAE5B;EACE,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wBAAwB;;AAExB,iBAAiB;AACjB;;EAEE,iBAAiB;EACjB,uCAAuC;EACvC,4CAA4C;EAC5C,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB,iBAAiB;AACjB;;EAEE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B,iBAAiB;AACjB;;EAEE,uCAAuC;EACvC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,mBAAmB;EACnB;wCACsC;EACtC,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,YAAY,EAAE,gEAAgE;EAC9E,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,0DAA0D;EAC1D,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;EACnB,uDAAuD;EACvD,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,kDAAkD;AACpD;AACA,iBAAiB;AACjB;;EAEE,wDAAwD;AAC1D;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;AAC7C;;AAEA;4CAC4C;AAC5C,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,8BAA8B;;AAE9B,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,4CAA4C;;EAE5C;;iEAE+D;EAC/D,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;;EAEE;wCACsC;EACtC,0DAA0D;EAC1D,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;EAC9C,wBAAwB;EACxB,cAAc;EACd,eAAe;;EAEf;;iEAE+D;EAC/D,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,wDAAwD;AAC1D;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;EAC5C,iEAAiE;EACjE;;GAEC;EACD;;GAEC;AACH;;AAEA,2BAA2B;;AAE3B,iBAAiB;AACjB;;EAEE,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;AAC7C;;AAEA,0BAA0B;;AAE1B,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;EAEE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;EAC3C,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;EAC3C,gDAAgD;EAChD,yDAAyD;EACzD,WAAW;AACb;;AAEA,yBAAyB;;AAEzB,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,cAAc;EACd,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;;EAEE,sCAAsC;EACtC,uCAAuC;EACvC,cAAc,EAAE,4DAA4D;EAC5E,oDAAoD;EACpD,oCAAoC;EACpC;wCACsC;EACtC,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;;EAEE;wCACsC;AACxC;;AAEA,iBAAiB;AACjB;;;;EAIE,wDAAwD;AAC1D;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,wBAAwB;EACxB,uCAAuC;EACvC,4CAA4C;EAC5C,oDAAoD;EACpD,oCAAoC;EACpC;wCACsC;EACtC,sCAAsC;EACtC;6CAC2C;EAC3C,YAAY,EAAE,gEAAgE;EAC9E,cAAc;EACd,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;AAC7C;;AAEA,wBAAwB;;AAExB,iBAAiB;AACjB;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,cAAc;EACd,YAAY,EAAE,gEAAgE;EAC9E,wBAAwB;EACxB,uCAAuC;EACvC;wCACsC;EACtC,0DAA0D;EAC1D,oCAAoC;EACpC,sCAAsC;EACtC;6CAC2C;EAC3C,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;EAEE,wDAAwD;AAC1D;;AAEA,iBAAiB;AACjB;;EAEE,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;AAC7C;;AAEA,gBAAgB;;AAEhB,iBAAiB;AACjB;;EAEE,2CAA2C;EAC3C,aAAa;EACb,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA,iBAAiB;AACjB;;EAEE,2CAA2C;AAC7C;;AAEA,eAAe;;AAEf,iBAAiB;AACjB;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;;;EAGE,wFAAwF;EACxF,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;;EAGE,gDAAgD;EAChD,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;;AAEA,iBAAiB;AACjB;;EAEE,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,mCAAmC;EACnC,+BAA+B;EAC/B,4DAA4D;EAC5D,4CAA4C;EAC5C,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;;EAGE,8DAA8D;EAC9D;;GAEC;AACH;;AAEA,iBAAiB;AACjB;;;EAGE,gDAAgD;EAChD,eAAe;EACf;;GAEC;EACD,oDAAoD;EACpD,8CAA8C;EAC9C,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;;EAGE,+BAA+B;EAC/B,+DAA+D;EAC/D,mCAAmC;EACnC;;GAEC;EACD,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;;EAGE,kBAAkB;EAClB,sCAAsC;EACtC,uCAAuC;EACvC,WAAW;EACX,mDAAmD;EACnD,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;;;EAGE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;;;;;;;;;;;EAYE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;;;;;;;;;;;;;;;EAeE,gBAAgB;AAClB;;AAEA;6DAC6D;AAC7D,iBAAiB;AACjB;;;;;;;;;;;;;;;EAeE,wBAAwB;EACxB,gBAAgB,EAAE,UAAU;AAC9B;;AAEA,iBAAiB;AACjB;;;;;;;;;EASE,oDAAoD;AACtD;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,+BAA+B;EAC/B,yCAAyC;EACzC,oEAAoE;EACpE;uCACqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,+BAA+B;EAC/B,yEAAyE;EACzE,0EAA0E;EAC1E,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB,iBAAiB;AACjB;;;;EAIE,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;;;;EAIE,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iEAAiE;EACjE,4CAA4C;EAC5C,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB,iBAAiB;AACjB;;EAEE,eAAe;EACf,YAAY;AACd","sourcesContent":["/* Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n/*\n * We assume that the CSS variables in\n * https://github.com/jupyterlab/jupyterlab/blob/master/src/default-theme/variables.css\n * have been defined.\n */\n\n@import './lumino.css';\n@import './nouislider.css';\n\n:root {\n  --jp-widgets-color: var(--jp-content-font-color1);\n  --jp-widgets-label-color: var(--jp-widgets-color);\n  --jp-widgets-readout-color: var(--jp-widgets-color);\n  --jp-widgets-font-size: var(--jp-ui-font-size1);\n  --jp-widgets-margin: 2px;\n  --jp-widgets-inline-height: 28px;\n  --jp-widgets-inline-width: 300px;\n  --jp-widgets-inline-width-short: calc(\n    var(--jp-widgets-inline-width) / 2 - var(--jp-widgets-margin)\n  );\n  --jp-widgets-inline-width-tiny: calc(\n    var(--jp-widgets-inline-width-short) / 2 - var(--jp-widgets-margin)\n  );\n  --jp-widgets-inline-margin: 4px; /* margin between inline elements */\n  --jp-widgets-inline-label-width: 80px;\n  --jp-widgets-border-width: var(--jp-border-width);\n  --jp-widgets-vertical-height: 200px;\n  --jp-widgets-horizontal-tab-height: 24px;\n  --jp-widgets-horizontal-tab-width: 144px;\n  --jp-widgets-horizontal-tab-top-border: 2px;\n  --jp-widgets-progress-thickness: 20px;\n  --jp-widgets-container-padding: 15px;\n  --jp-widgets-input-padding: 4px;\n  --jp-widgets-radio-item-height-adjustment: 8px;\n  --jp-widgets-radio-item-height: calc(\n    var(--jp-widgets-inline-height) -\n      var(--jp-widgets-radio-item-height-adjustment)\n  );\n  --jp-widgets-slider-track-thickness: 4px;\n  --jp-widgets-slider-border-width: var(--jp-widgets-border-width);\n  --jp-widgets-slider-handle-size: 16px;\n  --jp-widgets-slider-handle-border-color: var(--jp-border-color1);\n  --jp-widgets-slider-handle-background-color: var(--jp-layout-color1);\n  --jp-widgets-slider-active-handle-color: var(--jp-brand-color1);\n  --jp-widgets-menu-item-height: 24px;\n  --jp-widgets-dropdown-arrow: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOCAxOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTggMTg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO30KPC9zdHlsZT4KPHBhdGggZD0iTTUuMiw1LjlMOSw5LjdsMy44LTMuOGwxLjIsMS4ybC00LjksNWwtNC45LTVMNS4yLDUuOXoiLz4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTAtMC42aDE4djE4SDBWLTAuNnoiLz4KPC9zdmc+Cg');\n  --jp-widgets-input-color: var(--jp-ui-font-color1);\n  --jp-widgets-input-background-color: var(--jp-layout-color1);\n  --jp-widgets-input-border-color: var(--jp-border-color1);\n  --jp-widgets-input-focus-border-color: var(--jp-brand-color2);\n  --jp-widgets-input-border-width: var(--jp-widgets-border-width);\n  --jp-widgets-disabled-opacity: 0.6;\n\n  /* From Material Design Lite */\n  --md-shadow-key-umbra-opacity: 0.2;\n  --md-shadow-key-penumbra-opacity: 0.14;\n  --md-shadow-ambient-shadow-opacity: 0.12;\n}\n\n.jupyter-widgets {\n  margin: var(--jp-widgets-margin);\n  box-sizing: border-box;\n  color: var(--jp-widgets-color);\n  overflow: visible;\n}\n\n.jp-Output-result > .jupyter-widgets {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* vbox and hbox */\n\n/* <DEPRECATED> */\n.widget-inline-hbox, /* </DEPRECATED> */\n .jupyter-widget-inline-hbox {\n  /* Horizontal widgets */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n\n/* <DEPRECATED> */\n.widget-inline-vbox, /* </DEPRECATED> */\n .jupyter-widget-inline-vbox {\n  /* Vertical Widgets */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* <DEPRECATED> */\n.widget-box, /* </DEPRECATED> */\n.jupyter-widget-box {\n  box-sizing: border-box;\n  display: flex;\n  margin: 0;\n  overflow: auto;\n}\n\n/* <DEPRECATED> */\n.widget-gridbox, /* </DEPRECATED> */\n.jupyter-widget-gridbox {\n  box-sizing: border-box;\n  display: grid;\n  margin: 0;\n  overflow: auto;\n}\n\n/* <DEPRECATED> */\n.widget-hbox, /* </DEPRECATED> */\n.jupyter-widget-hbox {\n  flex-direction: row;\n}\n\n/* <DEPRECATED> */\n.widget-vbox, /* </DEPRECATED> */\n.jupyter-widget-vbox {\n  flex-direction: column;\n}\n\n/* General Tags Styling */\n\n.jupyter-widget-tagsinput {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  overflow: auto;\n\n  cursor: text;\n}\n\n.jupyter-widget-tag {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  font-size: var(--jp-widgets-font-size);\n\n  height: calc(var(--jp-widgets-inline-height) - 2px);\n  border: 0px solid;\n  line-height: calc(var(--jp-widgets-inline-height) - 2px);\n  box-shadow: none;\n\n  color: var(--jp-ui-font-color1);\n  background-color: var(--jp-layout-color2);\n  border-color: var(--jp-border-color2);\n  border: none;\n  user-select: none;\n\n  cursor: grab;\n  transition: margin-left 200ms;\n  margin: 1px 1px 1px 1px;\n}\n\n.jupyter-widget-tag.mod-active {\n  /* MD Lite 4dp shadow */\n  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),\n    0 1px 10px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity)),\n    0 2px 4px -1px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity));\n  color: var(--jp-ui-font-color1);\n  background-color: var(--jp-layout-color3);\n}\n\n.jupyter-widget-colortag {\n  color: var(--jp-inverse-ui-font-color1);\n}\n\n.jupyter-widget-colortag.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n}\n\n.jupyter-widget-taginput {\n  color: var(--jp-ui-font-color0);\n  background-color: var(--jp-layout-color0);\n\n  cursor: text;\n  text-align: left;\n}\n\n.jupyter-widget-taginput:focus {\n  outline: none;\n}\n\n.jupyter-widget-tag-close {\n  margin-left: var(--jp-widgets-inline-margin);\n  padding: 2px 0px 2px 2px;\n}\n\n.jupyter-widget-tag-close:hover {\n  cursor: pointer;\n}\n\n/* Tag \"Primary\" Styling */\n\n.jupyter-widget-tag.mod-primary {\n  color: var(--jp-inverse-ui-font-color1);\n  background-color: var(--jp-brand-color1);\n}\n\n.jupyter-widget-tag.mod-primary.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n  background-color: var(--jp-brand-color0);\n}\n\n/* Tag \"Success\" Styling */\n\n.jupyter-widget-tag.mod-success {\n  color: var(--jp-inverse-ui-font-color1);\n  background-color: var(--jp-success-color1);\n}\n\n.jupyter-widget-tag.mod-success.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n  background-color: var(--jp-success-color0);\n}\n\n/* Tag \"Info\" Styling */\n\n.jupyter-widget-tag.mod-info {\n  color: var(--jp-inverse-ui-font-color1);\n  background-color: var(--jp-info-color1);\n}\n\n.jupyter-widget-tag.mod-info.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n  background-color: var(--jp-info-color0);\n}\n\n/* Tag \"Warning\" Styling */\n\n.jupyter-widget-tag.mod-warning {\n  color: var(--jp-inverse-ui-font-color1);\n  background-color: var(--jp-warn-color1);\n}\n\n.jupyter-widget-tag.mod-warning.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n  background-color: var(--jp-warn-color0);\n}\n\n/* Tag \"Danger\" Styling */\n\n.jupyter-widget-tag.mod-danger {\n  color: var(--jp-inverse-ui-font-color1);\n  background-color: var(--jp-error-color1);\n}\n\n.jupyter-widget-tag.mod-danger.mod-active {\n  color: var(--jp-inverse-ui-font-color0);\n  background-color: var(--jp-error-color0);\n}\n\n/* General Button Styling */\n\n.jupyter-button {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  font-size: var(--jp-widgets-font-size);\n  cursor: pointer;\n\n  height: var(--jp-widgets-inline-height);\n  border: 0px solid;\n  line-height: var(--jp-widgets-inline-height);\n  box-shadow: none;\n\n  color: var(--jp-ui-font-color1);\n  background-color: var(--jp-layout-color2);\n  border-color: var(--jp-border-color2);\n  border: none;\n  user-select: none;\n}\n\n.jupyter-button i.fa {\n  margin-right: var(--jp-widgets-inline-margin);\n  pointer-events: none;\n}\n\n.jupyter-button:empty:before {\n  content: '\\200b'; /* zero-width space */\n}\n\n.jupyter-widgets.jupyter-button:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n.jupyter-button i.fa.center {\n  margin-right: 0;\n}\n\n.jupyter-button:hover:enabled,\n.jupyter-button:focus:enabled {\n  /* MD Lite 2dp shadow */\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),\n    0 3px 1px -2px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity)),\n    0 1px 5px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity));\n}\n\n.jupyter-button:active,\n.jupyter-button.mod-active {\n  /* MD Lite 4dp shadow */\n  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, var(--md-shadow-key-penumbra-opacity)),\n    0 1px 10px 0 rgba(0, 0, 0, var(--md-shadow-ambient-shadow-opacity)),\n    0 2px 4px -1px rgba(0, 0, 0, var(--md-shadow-key-umbra-opacity));\n  color: var(--jp-ui-font-color1);\n  background-color: var(--jp-layout-color3);\n}\n\n.jupyter-button:focus:enabled {\n  outline: 1px solid var(--jp-widgets-input-focus-border-color);\n}\n\n/* Button \"Primary\" Styling */\n\n.jupyter-button.mod-primary {\n  color: var(--jp-ui-inverse-font-color1);\n  background-color: var(--jp-brand-color1);\n}\n\n.jupyter-button.mod-primary.mod-active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-brand-color0);\n}\n\n.jupyter-button.mod-primary:active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-brand-color0);\n}\n\n/* Button \"Success\" Styling */\n\n.jupyter-button.mod-success {\n  color: var(--jp-ui-inverse-font-color1);\n  background-color: var(--jp-success-color1);\n}\n\n.jupyter-button.mod-success.mod-active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-success-color0);\n}\n\n.jupyter-button.mod-success:active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-success-color0);\n}\n\n/* Button \"Info\" Styling */\n\n.jupyter-button.mod-info {\n  color: var(--jp-ui-inverse-font-color1);\n  background-color: var(--jp-info-color1);\n}\n\n.jupyter-button.mod-info.mod-active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-info-color0);\n}\n\n.jupyter-button.mod-info:active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-info-color0);\n}\n\n/* Button \"Warning\" Styling */\n\n.jupyter-button.mod-warning {\n  color: var(--jp-ui-inverse-font-color1);\n  background-color: var(--jp-warn-color1);\n}\n\n.jupyter-button.mod-warning.mod-active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-warn-color0);\n}\n\n.jupyter-button.mod-warning:active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-warn-color0);\n}\n\n/* Button \"Danger\" Styling */\n\n.jupyter-button.mod-danger {\n  color: var(--jp-ui-inverse-font-color1);\n  background-color: var(--jp-error-color1);\n}\n\n.jupyter-button.mod-danger.mod-active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-error-color0);\n}\n\n.jupyter-button.mod-danger:active {\n  color: var(--jp-ui-inverse-font-color0);\n  background-color: var(--jp-error-color0);\n}\n\n/* Widget Button, Widget Toggle Button, Widget Upload */\n\n/* <DEPRECATED> */\n.widget-button, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-toggle-button, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-upload, /* </DEPRECATED> */\n.jupyter-widget-button,\n.jupyter-widget-toggle-button,\n.jupyter-widget-upload {\n  width: var(--jp-widgets-inline-width-short);\n}\n\n/* Widget Label Styling */\n\n/* Override Bootstrap label css */\n.jupyter-widgets label {\n  margin-bottom: initial;\n}\n\n/* <DEPRECATED> */\n.widget-label-basic, /* </DEPRECATED> */\n.jupyter-widget-label-basic {\n  /* Basic Label */\n  color: var(--jp-widgets-label-color);\n  font-size: var(--jp-widgets-font-size);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-label, /* </DEPRECATED> */\n.jupyter-widget-label {\n  /* Label */\n  color: var(--jp-widgets-label-color);\n  font-size: var(--jp-widgets-font-size);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-inline-hbox .widget-label, /* </DEPRECATED> */\n.jupyter-widget-inline-hbox .jupyter-widget-label {\n  /* Horizontal Widget Label */\n  color: var(--jp-widgets-label-color);\n  text-align: right;\n  margin-right: calc(var(--jp-widgets-inline-margin) * 2);\n  width: var(--jp-widgets-inline-label-width);\n  flex-shrink: 0;\n}\n\n/* <DEPRECATED> */\n.widget-inline-vbox .widget-label, /* </DEPRECATED> */\n.jupyter-widget-inline-vbox .jupyter-widget-label {\n  /* Vertical Widget Label */\n  color: var(--jp-widgets-label-color);\n  text-align: center;\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* Widget Readout Styling */\n\n/* <DEPRECATED> */\n.widget-readout, /* </DEPRECATED> */\n.jupyter-widget-readout {\n  color: var(--jp-widgets-readout-color);\n  font-size: var(--jp-widgets-font-size);\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: center;\n}\n\n/* <DEPRECATED> */\n.widget-readout.overflow, /* </DEPRECATED> */\n.jupyter-widget-readout.overflow {\n  /* Overflowing Readout */\n\n  /* From Material Design Lite\n        shadow-key-umbra-opacity: 0.2;\n        shadow-key-penumbra-opacity: 0.14;\n        shadow-ambient-shadow-opacity: 0.12;\n     */\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2),\n    0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2),\n    0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.14),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n/* <DEPRECATED> */\n.widget-inline-hbox .widget-readout, /* </DEPRECATED> */\n.jupyter-widget-inline-hbox .jupyter-widget-readout {\n  /* Horizontal Readout */\n  text-align: center;\n  max-width: var(--jp-widgets-inline-width-short);\n  min-width: var(--jp-widgets-inline-width-tiny);\n  margin-left: var(--jp-widgets-inline-margin);\n}\n\n/* <DEPRECATED> */\n.widget-inline-vbox .widget-readout, /* </DEPRECATED> */\n.jupyter-widget-inline-vbox .jupyter-widget-readout {\n  /* Vertical Readout */\n  margin-top: var(--jp-widgets-inline-margin);\n  /* as wide as the widget */\n  width: inherit;\n}\n\n/* Widget Checkbox Styling */\n\n/* <DEPRECATED> */\n.widget-checkbox, /* </DEPRECATED> */\n.jupyter-widget-checkbox {\n  width: var(--jp-widgets-inline-width);\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-checkbox input[type='checkbox'], /* </DEPRECATED> */\n.jupyter-widget-checkbox input[type='checkbox'] {\n  margin: 0px calc(var(--jp-widgets-inline-margin) * 2) 0px 0px;\n  line-height: var(--jp-widgets-inline-height);\n  font-size: large;\n  flex-grow: 1;\n  flex-shrink: 0;\n  align-self: center;\n}\n\n/* Widget Valid Styling */\n\n/* <DEPRECATED> */\n.widget-valid, /* </DEPRECATED> */\n.jupyter-widget-valid {\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n  width: var(--jp-widgets-inline-width-short);\n  font-size: var(--jp-widgets-font-size);\n}\n\n/* <DEPRECATED> */\n.widget-valid i, /* </DEPRECATED> */\n.jupyter-widget-valid i {\n  line-height: var(--jp-widgets-inline-height);\n  margin-right: var(--jp-widgets-inline-margin);\n  margin-left: var(--jp-widgets-inline-margin);\n}\n\n/* <DEPRECATED> */\n.widget-valid.mod-valid i, /* </DEPRECATED> */\n.jupyter-widget-valid.mod-valid i {\n  color: green;\n}\n\n/* <DEPRECATED> */\n.widget-valid.mod-invalid i, /* </DEPRECATED> */\n.jupyter-widget-valid.mod-invalid i {\n  color: red;\n}\n\n/* <DEPRECATED> */\n.widget-valid.mod-valid .widget-valid-readout, /* </DEPRECATED> */\n.jupyter-widget-valid.mod-valid .jupyter-widget-valid-readout {\n  display: none;\n}\n\n/* Widget Text and TextArea Styling */\n\n/* <DEPRECATED> */\n.widget-textarea, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text, /* </DEPRECATED> */\n.jupyter-widget-textarea,\n.jupyter-widget-text {\n  width: var(--jp-widgets-inline-width);\n}\n\n/* <DEPRECATED> */\n.widget-text input[type='text'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='number'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */\n.jupyter-widget-text input[type='text'],\n.jupyter-widget-text input[type='number'],\n.jupyter-widget-text input[type='password'] {\n  height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-text input[type='text']:disabled, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='number']:disabled, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='password']:disabled, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-textarea textarea:disabled, /* </DEPRECATED> */\n.jupyter-widget-text input[type='text']:disabled,\n.jupyter-widget-text input[type='number']:disabled,\n.jupyter-widget-text input[type='password']:disabled,\n.jupyter-widget-textarea textarea:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* <DEPRECATED> */\n.widget-text input[type='text'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='number'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-textarea textarea, /* </DEPRECATED> */\n.jupyter-widget-text input[type='text'],\n.jupyter-widget-text input[type='number'],\n.jupyter-widget-text input[type='password'],\n.jupyter-widget-textarea textarea {\n  box-sizing: border-box;\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  background-color: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  font-size: var(--jp-widgets-font-size);\n  flex-grow: 1;\n  min-width: 0; /* This makes it possible for the flexbox to shrink this input */\n  flex-shrink: 1;\n  outline: none !important;\n}\n\n/* <DEPRECATED> */\n.widget-text input[type='text'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-text input[type='password'], /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-textarea textarea, /* </DEPRECATED> */\n.jupyter-widget-text input[type='text'],\n.jupyter-widget-text input[type='password'],\n.jupyter-widget-textarea textarea {\n  padding: var(--jp-widgets-input-padding)\n    calc(var(--jp-widgets-input-padding) * 2);\n}\n\n/* <DEPRECATED> */\n.widget-text input[type='number'], /* </DEPRECATED> */\n.jupyter-widget-text input[type='number'] {\n  padding: var(--jp-widgets-input-padding) 0 var(--jp-widgets-input-padding)\n    calc(var(--jp-widgets-input-padding) * 2);\n}\n\n/* <DEPRECATED> */\n.widget-textarea textarea, /* </DEPRECATED> */\n.jupyter-widget-textarea textarea {\n  height: inherit;\n  width: inherit;\n}\n\n/* <DEPRECATED> */\n.widget-text input:focus, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-textarea textarea:focus, /* </DEPRECATED> */\n.jupyter-widget-text input:focus,\n.jupyter-widget-textarea textarea:focus {\n  border-color: var(--jp-widgets-input-focus-border-color);\n}\n\n/* Horizontal Slider */\n/* <DEPRECATED> */\n.widget-hslider, /* </DEPRECATED> */\n.jupyter-widget-hslider {\n  width: var(--jp-widgets-inline-width);\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n\n  /* Override the align-items baseline. This way, the description and readout\n    still seem to align their baseline properly, and we don't have to have\n    align-self: stretch in the .slider-container. */\n  align-items: center;\n}\n\n/* <DEPRECATED> */\n.widgets-slider .slider-container, /* </DEPRECATED> */\n.jupyter-widgets-slider .slider-container {\n  overflow: visible;\n}\n\n/* <DEPRECATED> */\n.widget-hslider .slider-container, /* </DEPRECATED> */\n.jupyter-widget-hslider .slider-container {\n  margin-left: calc(\n    var(--jp-widgets-slider-handle-size) / 2 - 2 *\n      var(--jp-widgets-slider-border-width)\n  );\n  margin-right: calc(\n    var(--jp-widgets-slider-handle-size) / 2 - 2 *\n      var(--jp-widgets-slider-border-width)\n  );\n  flex: 1 1 var(--jp-widgets-inline-width-short);\n}\n\n/* Vertical Slider */\n\n/* <DEPRECATED> */\n.widget-vbox .widget-label, /* </DEPRECATED> */\n.jupyter-widget-vbox .jupyter-widget-label {\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-vslider, /* </DEPRECATED> */\n.jupyter-widget-vslider {\n  /* Vertical Slider */\n  height: var(--jp-widgets-vertical-height);\n  width: var(--jp-widgets-inline-width-tiny);\n}\n\n/* <DEPRECATED> */\n.widget-vslider .slider-container, /* </DEPRECATED> */\n.jupyter-widget-vslider .slider-container {\n  flex: 1 1 var(--jp-widgets-inline-width-short);\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: calc(\n    var(--jp-widgets-slider-handle-size) / 2 - 2 *\n      var(--jp-widgets-slider-border-width)\n  );\n  margin-top: calc(\n    var(--jp-widgets-slider-handle-size) / 2 - 2 *\n      var(--jp-widgets-slider-border-width)\n  );\n  display: flex;\n  flex-direction: column;\n}\n\n/* Widget Progress Styling */\n\n.progress-bar {\n  -webkit-transition: none;\n  -moz-transition: none;\n  -ms-transition: none;\n  -o-transition: none;\n  transition: none;\n}\n\n.progress-bar {\n  height: var(--jp-widgets-inline-height);\n}\n\n.progress-bar {\n  background-color: var(--jp-brand-color1);\n}\n\n.progress-bar-success {\n  background-color: var(--jp-success-color1);\n}\n\n.progress-bar-info {\n  background-color: var(--jp-info-color1);\n}\n\n.progress-bar-warning {\n  background-color: var(--jp-warn-color1);\n}\n\n.progress-bar-danger {\n  background-color: var(--jp-error-color1);\n}\n\n.progress {\n  background-color: var(--jp-layout-color2);\n  border: none;\n  box-shadow: none;\n}\n\n/* Horisontal Progress */\n\n/* <DEPRECATED> */\n.widget-hprogress, /* </DEPRECATED> */\n.jupyter-widget-hprogress {\n  /* Progress Bar */\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n  width: var(--jp-widgets-inline-width);\n  align-items: center;\n}\n\n/* <DEPRECATED> */\n.widget-hprogress .progress, /* </DEPRECATED> */\n.jupyter-widget-hprogress .progress {\n  flex-grow: 1;\n  margin-top: var(--jp-widgets-input-padding);\n  margin-bottom: var(--jp-widgets-input-padding);\n  align-self: stretch;\n  /* Override bootstrap style */\n  height: initial;\n}\n\n/* Vertical Progress */\n\n/* <DEPRECATED> */\n.widget-vprogress, /* </DEPRECATED> */\n.jupyter-widget-vprogress {\n  height: var(--jp-widgets-vertical-height);\n  width: var(--jp-widgets-inline-width-tiny);\n}\n\n/* <DEPRECATED> */\n.widget-vprogress .progress, /* </DEPRECATED> */\n.jupyter-widget-vprogress .progress {\n  flex-grow: 1;\n  width: var(--jp-widgets-progress-thickness);\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0;\n}\n\n/* Select Widget Styling */\n\n/* <DEPRECATED> */\n.widget-dropdown, /* </DEPRECATED> */\n.jupyter-widget-dropdown {\n  height: var(--jp-widgets-inline-height);\n  width: var(--jp-widgets-inline-width);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-dropdown > select, /* </DEPRECATED> */\n.jupyter-widget-dropdown > select {\n  padding-right: 20px;\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  border-radius: 0;\n  height: inherit;\n  flex: 1 1 var(--jp-widgets-inline-width-short);\n  min-width: 0; /* This makes it possible for the flexbox to shrink this input */\n  box-sizing: border-box;\n  outline: none !important;\n  box-shadow: none;\n  background-color: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  font-size: var(--jp-widgets-font-size);\n  vertical-align: top;\n  padding-left: calc(var(--jp-widgets-input-padding) * 2);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: right center;\n  background-image: var(--jp-widgets-dropdown-arrow);\n}\n/* <DEPRECATED> */\n.widget-dropdown > select:focus, /* </DEPRECATED> */\n.jupyter-widget-dropdown > select:focus {\n  border-color: var(--jp-widgets-input-focus-border-color);\n}\n\n/* <DEPRECATED> */\n.widget-dropdown > select:disabled, /* </DEPRECATED> */\n.jupyter-widget-dropdown > select:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* To disable the dotted border in Firefox around select controls.\n   See http://stackoverflow.com/a/18853002 */\n/* <DEPRECATED> */\n.widget-dropdown > select:-moz-focusring, /* </DEPRECATED> */\n.jupyter-widget-dropdown > select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n/* Select and SelectMultiple */\n\n/* <DEPRECATED> */\n.widget-select, /* </DEPRECATED> */\n.jupyter-widget-select {\n  width: var(--jp-widgets-inline-width);\n  line-height: var(--jp-widgets-inline-height);\n\n  /* Because Firefox defines the baseline of a select as the bottom of the\n    control, we align the entire control to the top and add padding to the\n    select to get an approximate first line baseline alignment. */\n  align-items: flex-start;\n}\n\n/* <DEPRECATED> */\n.widget-select > select, /* </DEPRECATED> */\n.jupyter-widget-select > select {\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  background-color: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  font-size: var(--jp-widgets-font-size);\n  flex: 1 1 var(--jp-widgets-inline-width-short);\n  outline: none !important;\n  overflow: auto;\n  height: inherit;\n\n  /* Because Firefox defines the baseline of a select as the bottom of the\n    control, we align the entire control to the top and add padding to the\n    select to get an approximate first line baseline alignment. */\n  padding-top: 5px;\n}\n\n/* <DEPRECATED> */\n.widget-select > select:focus, /* </DEPRECATED> */\n.jupyter-widget-select > select:focus {\n  border-color: var(--jp-widgets-input-focus-border-color);\n}\n\n.wiget-select > select > option,\n.jupyter-wiget-select > select > option {\n  padding-left: var(--jp-widgets-input-padding);\n  line-height: var(--jp-widgets-inline-height);\n  /* line-height doesn't work on some browsers for select options */\n  padding-top: calc(\n    var(--jp-widgets-inline-height) - var(--jp-widgets-font-size) / 2\n  );\n  padding-bottom: calc(\n    var(--jp-widgets-inline-height) - var(--jp-widgets-font-size) / 2\n  );\n}\n\n/* Toggle Buttons Styling */\n\n/* <DEPRECATED> */\n.widget-toggle-buttons, /* </DEPRECATED> */\n.jupyter-widget-toggle-buttons {\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-toggle-buttons .widget-toggle-button, /* </DEPRECATED> */\n.jupyter-widget-toggle-buttons .jupyter-widget-toggle-button {\n  margin-left: var(--jp-widgets-margin);\n  margin-right: var(--jp-widgets-margin);\n}\n\n/* <DEPRECATED> */\n.widget-toggle-buttons .jupyter-button:disabled, /* </DEPRECATED> */\n.jupyter-widget-toggle-buttons .jupyter-button:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* Radio Buttons Styling */\n\n/* <DEPRECATED> */\n.widget-radio, /* </DEPRECATED> */\n.jupyter-widget-radio {\n  width: var(--jp-widgets-inline-width);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-radio-box, /* </DEPRECATED> */\n.jupyter-widget-radio-box {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box;\n  flex-grow: 1;\n  margin-bottom: var(--jp-widgets-radio-item-height-adjustment);\n}\n\n/* <DEPRECATED> */\n.widget-radio-box-vertical, /* </DEPRECATED> */\n.jupyter-widget-radio-box-vertical {\n  flex-direction: column;\n}\n\n/* <DEPRECATED> */\n.widget-radio-box-horizontal, /* </DEPRECATED> */\n.jupyter-widget-radio-box-horizontal {\n  flex-direction: row;\n}\n\n/* <DEPRECATED> */\n.widget-radio-box label, /* </DEPRECATED> */\n.jupyter-widget-radio-box label {\n  height: var(--jp-widgets-radio-item-height);\n  line-height: var(--jp-widgets-radio-item-height);\n  font-size: var(--jp-widgets-font-size);\n}\n\n.widget-radio-box-horizontal label,\n.jupyter-widget-radio-box-horizontal label {\n  margin: 0 calc(var(--jp-widgets-input-padding) * 2) 0 0;\n}\n\n/* <DEPRECATED> */\n.widget-radio-box input, /* </DEPRECATED> */\n.jupyter-widget-radio-box input {\n  height: var(--jp-widgets-radio-item-height);\n  line-height: var(--jp-widgets-radio-item-height);\n  margin: 0 calc(var(--jp-widgets-input-padding) * 2) 0 1px;\n  float: left;\n}\n\n/* Color Picker Styling */\n\n/* <DEPRECATED> */\n.widget-colorpicker, /* </DEPRECATED> */\n.jupyter-widget-colorpicker {\n  width: var(--jp-widgets-inline-width);\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker > .widget-colorpicker-input, /* </DEPRECATED> */\n.jupyter-widget-colorpicker > .jupyter-widget-colorpicker-input {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: var(--jp-widgets-inline-width-tiny);\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker input[type='color'], /* </DEPRECATED> */\n.jupyter-widget-colorpicker input[type='color'] {\n  width: var(--jp-widgets-inline-height);\n  height: var(--jp-widgets-inline-height);\n  padding: 0 2px; /* make the color square actually square on Chrome on OS X */\n  background: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  border-left: none;\n  flex-grow: 0;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  align-self: stretch;\n  outline: none !important;\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker.concise input[type='color'], /* </DEPRECATED> */\n.jupyter-widget-colorpicker.concise input[type='color'] {\n  border-left: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker input[type='color']:focus, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-colorpicker input[type='text']:focus, /* </DEPRECATED> */\n.jupyter-widget-colorpicker input[type='color']:focus,\n.jupyter-widget-colorpicker input[type='text']:focus {\n  border-color: var(--jp-widgets-input-focus-border-color);\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker input[type='text'], /* </DEPRECATED> */\n.jupyter-widget-colorpicker input[type='text'] {\n  flex-grow: 1;\n  outline: none !important;\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n  background: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  font-size: var(--jp-widgets-font-size);\n  padding: var(--jp-widgets-input-padding)\n    calc(var(--jp-widgets-input-padding) * 2);\n  min-width: 0; /* This makes it possible for the flexbox to shrink this input */\n  flex-shrink: 1;\n  box-sizing: border-box;\n}\n\n/* <DEPRECATED> */\n.widget-colorpicker input[type='text']:disabled, /* </DEPRECATED> */\n.jupyter-widget-colorpicker input[type='text']:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* Date Picker Styling */\n\n/* <DEPRECATED> */\n.widget-datepicker, /* </DEPRECATED> */\n.jupyter-widget-datepicker {\n  width: var(--jp-widgets-inline-width);\n  height: var(--jp-widgets-inline-height);\n  line-height: var(--jp-widgets-inline-height);\n}\n\n/* <DEPRECATED> */\n.widget-datepicker input[type='date'], /* </DEPRECATED> */\n.jupyter-widget-datepicker input[type='date'] {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0; /* This makes it possible for the flexbox to shrink this input */\n  outline: none !important;\n  height: var(--jp-widgets-inline-height);\n  border: var(--jp-widgets-input-border-width) solid\n    var(--jp-widgets-input-border-color);\n  background-color: var(--jp-widgets-input-background-color);\n  color: var(--jp-widgets-input-color);\n  font-size: var(--jp-widgets-font-size);\n  padding: var(--jp-widgets-input-padding)\n    calc(var(--jp-widgets-input-padding) * 2);\n  box-sizing: border-box;\n}\n\n/* <DEPRECATED> */\n.widget-datepicker input[type='date']:focus, /* </DEPRECATED> */\n.jupyter-widget-datepicker input[type='date']:focus {\n  border-color: var(--jp-widgets-input-focus-border-color);\n}\n\n/* <DEPRECATED> */\n.widget-datepicker input[type='date']:invalid, /* </DEPRECATED> */\n.jupyter-widget-datepicker input[type='date']:invalid {\n  border-color: var(--jp-warn-color1);\n}\n\n/* <DEPRECATED> */\n.widget-datepicker input[type='date']:disabled, /* </DEPRECATED> */\n.jupyter-widget-datepicker input[type='date']:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* Play Widget */\n\n/* <DEPRECATED> */\n.widget-play, /* </DEPRECATED> */\n.jupyter-widget-play {\n  width: var(--jp-widgets-inline-width-short);\n  display: flex;\n  align-items: stretch;\n}\n\n/* <DEPRECATED> */\n.widget-play .jupyter-button, /* </DEPRECATED> */\n.jupyter-widget-play .jupyter-button {\n  flex-grow: 1;\n  height: auto;\n}\n\n/* <DEPRECATED> */\n.widget-play .jupyter-button:disabled, /* </DEPRECATED> */\n.jupyter-widget-play .jupyter-button:disabled {\n  opacity: var(--jp-widgets-disabled-opacity);\n}\n\n/* Tab Widget */\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab {\n  display: flex;\n  flex-direction: column;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar {\n  /* Necessary so that a tab can be shifted down to overlay the border of the box below. */\n  overflow-x: visible;\n  overflow-y: visible;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar > .p-TabBar-content, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar > .p-TabBar-content, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar > .lm-TabBar-content {\n  /* Make sure that the tab grows from bottom up */\n  align-items: flex-end;\n  min-width: 0;\n  min-height: 0;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .widget-tab-contents, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .widget-tab-contents {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  background: var(--jp-layout-color1);\n  color: var(--jp-ui-font-color1);\n  border: var(--jp-border-width) solid var(--jp-border-color1);\n  padding: var(--jp-widgets-container-padding);\n  flex-grow: 1;\n  overflow: auto;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar {\n  font: var(--jp-widgets-font-size) Helvetica, Arial, sans-serif;\n  min-height: calc(\n    var(--jp-widgets-horizontal-tab-height) + var(--jp-border-width)\n  );\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab {\n  flex: 0 1 var(--jp-widgets-horizontal-tab-width);\n  min-width: 35px;\n  min-height: calc(\n    var(--jp-widgets-horizontal-tab-height) + var(--jp-border-width)\n  );\n  line-height: var(--jp-widgets-horizontal-tab-height);\n  margin-left: calc(-1 * var(--jp-border-width));\n  padding: 0px 10px;\n  background: var(--jp-layout-color2);\n  color: var(--jp-ui-font-color2);\n  border: var(--jp-border-width) solid var(--jp-border-color1);\n  border-bottom: none;\n  position: relative;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab.lm-mod-current {\n  color: var(--jp-ui-font-color0);\n  /* We want the background to match the tab content background */\n  background: var(--jp-layout-color1);\n  min-height: calc(\n    var(--jp-widgets-horizontal-tab-height) + 2 * var(--jp-border-width)\n  );\n  transform: translateY(var(--jp-border-width));\n  overflow: visible;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current:before, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab.p-mod-current:before, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab.lm-mod-current:before {\n  position: absolute;\n  top: calc(-1 * var(--jp-border-width));\n  left: calc(-1 * var(--jp-border-width));\n  content: '';\n  height: var(--jp-widgets-horizontal-tab-top-border);\n  width: calc(100% + 2 * var(--jp-border-width));\n  background: var(--jp-brand-color1);\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tab:first-child, /* </DEPRECATED> */\n/* <DEPRECATED> */.jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tab:first-child, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tab:first-child {\n  margin-left: 0;\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab\n  > .p-TabBar\n  .p-TabBar-tab:hover:not(.p-mod-current),\n/* </DEPRECATED> */\n/* <DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab\n  > .p-TabBar\n  .p-TabBar-tab:hover:not(.p-mod-current),\n/* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab\n  > .lm-TabBar\n  .lm-TabBar-tab:hover:not(.lm-mod-current) {\n  background: var(--jp-layout-color1);\n  color: var(--jp-ui-font-color1);\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab\n  > .p-TabBar\n  .p-mod-closable\n  > .p-TabBar-tabCloseIcon,\n/* </DEPRECATED> */\n/* <DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab\n> .p-TabBar\n.p-mod-closable\n> .p-TabBar-tabCloseIcon,\n/* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab\n  > .lm-TabBar\n  .lm-mod-closable\n  > .lm-TabBar-tabCloseIcon {\n  margin-left: 4px;\n}\n\n/* This font-awesome strategy may not work across FA4 and FA5, but we don't\nactually support closable tabs, so it really doesn't matter */\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab\n  > .p-TabBar\n  .p-mod-closable\n  > .p-TabBar-tabCloseIcon:before,\n/* </DEPRECATED> */\n/* <DEPRECATED> */\n.jupyter-widgets.jupyter-widget-widget-tab\n> .p-TabBar\n.p-mod-closable\n> .p-TabBar-tabCloseIcon:before,\n/* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab\n  > .lm-TabBar\n  .lm-mod-closable\n  > .lm-TabBar-tabCloseIcon:before {\n  font-family: FontAwesome;\n  content: '\\f00d'; /* close */\n}\n\n/* <DEPRECATED> */\n.jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabIcon, /* </DEPRECATED> */\n/* <DEPRECATED> */ .jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabLabel, /* </DEPRECATED> */\n/* <DEPRECATED> */ .jupyter-widgets.widget-tab > .p-TabBar .p-TabBar-tabCloseIcon, /* </DEPRECATED> */\n/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabIcon, /* </DEPRECATED> */\n/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabLabel, /* </DEPRECATED> */\n/* <DEPRECATED> */ .jupyter-widgets.jupyter-widget-tab > .p-TabBar .p-TabBar-tabCloseIcon, /* </DEPRECATED> */\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabIcon,\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabLabel,\n.jupyter-widgets.jupyter-widget-tab > .lm-TabBar .lm-TabBar-tabCloseIcon {\n  line-height: var(--jp-widgets-horizontal-tab-height);\n}\n\n/* Accordion Widget */\n\n.jupyter-widget-Collapse {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.jupyter-widget-Collapse-header {\n  padding: var(--jp-widgets-input-padding);\n  cursor: pointer;\n  color: var(--jp-ui-font-color2);\n  background-color: var(--jp-layout-color2);\n  border: var(--jp-widgets-border-width) solid var(--jp-border-color1);\n  padding: calc(var(--jp-widgets-container-padding) * 2 / 3)\n    var(--jp-widgets-container-padding);\n  font-weight: bold;\n}\n\n.jupyter-widget-Collapse-header:hover {\n  background-color: var(--jp-layout-color1);\n  color: var(--jp-ui-font-color1);\n}\n\n.jupyter-widget-Collapse-open > .jupyter-widget-Collapse-header {\n  background-color: var(--jp-layout-color1);\n  color: var(--jp-ui-font-color0);\n  cursor: default;\n  border-bottom: none;\n}\n\n.jupyter-widget-Collapse-contents {\n  padding: var(--jp-widgets-container-padding);\n  background-color: var(--jp-layout-color1);\n  color: var(--jp-ui-font-color1);\n  border-left: var(--jp-widgets-border-width) solid var(--jp-border-color1);\n  border-right: var(--jp-widgets-border-width) solid var(--jp-border-color1);\n  border-bottom: var(--jp-widgets-border-width) solid var(--jp-border-color1);\n  overflow: auto;\n}\n\n.jupyter-widget-Accordion {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.jupyter-widget-Accordion .jupyter-widget-Collapse {\n  margin-bottom: 0;\n}\n\n.jupyter-widget-Accordion .jupyter-widget-Collapse + .jupyter-widget-Collapse {\n  margin-top: 4px;\n}\n\n/* HTML widget */\n\n/* <DEPRECATED> */\n.widget-html, /* </DEPRECATED> */\n/* <DEPRECATED> */ .widget-htmlmath, /* </DEPRECATED> */\n.jupyter-widget-html,\n.jupyter-widget-htmlmath {\n  font-size: var(--jp-widgets-font-size);\n}\n\n/* <DEPRECATED> */\n.widget-html > .widget-html-content, /* </DEPRECATED> */\n/* <DEPRECATED> */.widget-htmlmath > .widget-html-content, /* </DEPRECATED> */\n.jupyter-widget-html > .jupyter-widget-html-content,\n.jupyter-widget-htmlmath > .jupyter-widget-html-content {\n  /* Fill out the area in the HTML widget */\n  align-self: stretch;\n  flex-grow: 1;\n  flex-shrink: 1;\n  /* Makes sure the baseline is still aligned with other elements */\n  line-height: var(--jp-widgets-inline-height);\n  /* Make it possible to have absolutely-positioned elements in the html */\n  position: relative;\n}\n\n/* Image widget  */\n\n/* <DEPRECATED> */\n.widget-image, /* </DEPRECATED> */\n.jupyter-widget-image {\n  max-width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
